import { Routes } from "@angular/router";
import { CreatePackageComponent } from "src/components/create-package/create-package.component";
import { ContactComponent } from "src/components/contact/contact.component";
import { CategoriesComponent } from "src/components/create-ur-store/categories/categories.component";
import { CreateUrStoreComponent } from "src/components/create-ur-store/create-ur-store.component";
import { Error404Component } from "src/components/error404/error404.component";
import { HomeComponent } from "src/components/home/home.component";
import { IMakeAppComponent } from "src/components/i-make-app/i-make-app.component";
import { ProjectDetailsComponent } from "src/components/project-details/project-details.component";
import { AllLessonsComponent } from "src/components/static/all-lessons/all-lessons.component";
import { CarsAppComponent } from "src/components/static/cars-app/cars-app.component";
import { DesktopPageComponent } from "src/components/static/desktop-page/desktop-page.component";
import { HostingPageComponent } from "src/components/static/hosting-page/hosting-page.component";
import { LearningPageComponent } from "src/components/static/learning-page/learning-page.component";
import { LessonDetailsComponent } from "src/components/static/lesson-details/lesson-details.component";
import { MarketingPageComponent } from "src/components/static/marketing-page/marketing-page.component";
import { MobilePageComponent } from "src/components/static/mobile-page/mobile-page.component";
import { SeoPageComponent } from "src/components/static/seo-page/seo-page.component";
import { ShopPageComponent } from "src/components/static/shop-page/shop-page.component";
import { SupportPageComponent } from "src/components/static/support-page/support-page.component";
import { WebPageComponent } from "src/components/static/web-page/web-page.component";
import { CreateTicketComponent } from "src/components/create-ticket/create-ticket.component";
import { ProfileGuard } from "src/core/guards/profile.guard";
import { ChatRoomComponent } from "src/components/chat-room/chat-room.component";
import { Home2Component } from "src/components/home2/home2.component";
import { SchoolsSysyrmComponent } from "src/components/schools-sysyrm/index/schools-sysyrm.component";

export const APP_ROUTES: Routes = [
  // {
  //   path: '',
  //   component: HomeComponent,
  //   pathMatch: 'full'
  // },
  {
    path: "",
    pathMatch: "full",
    redirectTo: "home",
  },
  {
    path: "home",
    component: Home2Component,
  },
  {
    path: "دروس-تعليمية",
    component: LearningPageComponent,
  },
  {
    path: "posts/viewpost/:name",
    component: AllLessonsComponent,
  },
  {
    path: "posts/viewpost/details/:name/:catname",
    component: LessonDetailsComponent,
  },
  {
    path: "تفاصيل",
    component: ProjectDetailsComponent,
  },
  {
    path: "الدعم-الفني",
    component: SupportPageComponent,
  },
  {
    path: "ارشفة-مواقع",
    component: SeoPageComponent,
  },
  {
    path: "استضافة-مواقع",
    component: HostingPageComponent,
  },
  {
    path: "تصميم-مواقع",
    component: WebPageComponent,
  },
  {
    path: "تسويق-الكتروني",
    component: MarketingPageComponent,
  },
  {
    path: "برنامج ادارة السيارات المؤجرة",
    component: CarsAppComponent,
  },
  {
    path: "تصميم-برمجة-برامج",
    component: DesktopPageComponent,
  },
  {
    path: "تصميم-برمجة--تطبيقات-الموبايل",
    component: MobilePageComponent,
  },
  {
    path: "المتجر-الالكتروني-المتكامل",
    component: ShopPageComponent,
  },
  {
    path: "نظام ادارة المدارس",
    component: SchoolsSysyrmComponent,
  },
  {
    path: "تواصل-معنا",
    component: ContactComponent,
  },
  {
    path: "اختيار-القسم",
    component: CategoriesComponent,
  },
  {
    path: "انشيء تطبيق متجرك",
    component: CreateUrStoreComponent,
  },
  {
    path: "imakeapps",
    component: IMakeAppComponent,
  },
  {
    path: "auth",
    loadChildren: () =>
      import("../components/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "ourPackages",
    loadChildren: () =>
      import("../components/our-packages/our-packages.module").then(
        (m) => m.OurPackagesModule
      ),
  },
  {
    path: "create-package",
    component: CreatePackageComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: "create-ticket",
    component: CreateTicketComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: "payment",
    loadChildren: () =>
      import("../components/payment/payment.module").then(
        (m) => m.PaymentModule
      ),
  },
  {
    path: "chat-room/:ticket_id",
    component: ChatRoomComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: "**",
    component: Error404Component,
  },
];
